import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IInventoryState } from '../types/type.inventory';
import { fetchWarehouseList, onboardWarehouse } from '../thunk/thunk.inventory';
import { toast } from 'react-toastify';

const initialState: IInventoryState = {
	fetching: false,
	onboarding: false,
	fetchingAllInventory: false,
	remapping: false,
	totalWarehouse: 0,
	warehouseList: [],
	allInventory: [],
};

export const sliceInventory = createSlice({
	name: 'inventory',
	initialState,
	reducers: {
		filterByWarehouse: (state, action: PayloadAction<number>) => {
			//
		},
	},
	extraReducers: builder => {
		builder.addCase(fetchWarehouseList.pending, state => {
			state.fetching = true;
		});
		builder.addCase(fetchWarehouseList.fulfilled, (state, action) => {
			state.fetching = false;
			state.totalWarehouse = action.payload.totalWarehouse;
			state.warehouseList = action.payload.warehouseList;
		});
		builder.addCase(fetchWarehouseList.rejected, (state, action) => {
			state.fetching = false;
			const message = action.payload as string;
			toast(message, { type: 'error' });
		});

		builder.addCase(onboardWarehouse.pending, state => {
			state.onboarding = true;
		});
		builder.addCase(onboardWarehouse.fulfilled, (state, action) => {
			state.onboarding = false;
			toast(`Warehouse- ${action.payload} added successfully.`, {
				type: 'success',
			});
		});
		builder.addCase(onboardWarehouse.rejected, (state, action) => {
			state.onboarding = false;
			const message = action.payload as string;
			toast(message, { type: 'error' });
		});
	},
});

export default sliceInventory.reducer;
